export const frontmatter = {
    "draft": false,
    "title": "Guide: Tenant configuration",
    "description": "How to access and configure a Default Tenant or Enterprise Tenant in OnnIA: identification data, users, channels, and retention policies.",
    "sidebar_label": "Tenant configuration",
    "sidebar_group": "reference",
    "sidebar_order": 3
}

export const toc = [
    {
        "depth": 2,
        "id": "tenant-types",
        "value": "Tenant types"
    },
    {
        "depth": 2,
        "id": "accessing-a-tenant",
        "value": "Accessing a tenant"
    },
    {
        "depth": 2,
        "id": "general-configuration",
        "value": "General configuration"
    },
    {
        "depth": 3,
        "id": "identification-data",
        "value": "Identification data"
    },
    {
        "depth": 3,
        "id": "contact-information",
        "value": "Contact information"
    },
    {
        "depth": 3,
        "id": "address-and-location",
        "value": "Address and location"
    },
    {
        "depth": 3,
        "id": "visual-identity-and-language",
        "value": "Visual identity and language"
    },
    {
        "depth": 2,
        "id": "user-management",
        "value": "User management"
    },
    {
        "depth": 2,
        "id": "data-retention-policies",
        "value": "Data retention policies"
    },
    {
        "depth": 2,
        "id": "enterprise-tenant-additional-capabilities",
        "value": "Enterprise Tenant: additional capabilities"
    }
]